import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './style1.css';

interface AboutProps {
    username?: string | null;
    onLogout?: () => void;
}

const navLinks = [
    { name: 'HOME', href: '/' },
    { name: 'PROGRAMS', href: '/programs' },
    { name: 'VIDEOS', href: '/videos' },
    { name: 'IMAGES', href: '/images' }, // <-- Add this line
    { name: 'DEMOS', href: '/demos' },
    { name: 'CERTIFICATES', href: '/certificates' },
    { name: 'ABOUT', href: '/about' },
];

const About: React.FC<AboutProps> = ({ username, onLogout }) => {
    // Example: If you ever need to fetch protected data in About, use the token like this:
    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     fetch('/some-protected-endpoint', {
    //         headers: {
    //             'Authorization': `Bearer ${token}`
    //         }
    //     });
    // }, []);

    const [menuOpen, setMenuOpen] = useState(false);

    // Close nav on route change (optional, for better UX)
    // useEffect(() => { setNavOpen(false); }, [location]);

    return (
        <div className="modern-layout">
            <header className="modern-header">
                <div className="header-container">
                    <nav className={`modern-nav ${menuOpen ? 'open' : ''}`}>
                        {navLinks.map(link =>
                            link.href.startsWith('/')
                                ? <Link
                                    key={link.name}
                                    to={link.href}
                                    className="modern-nav-link"
                                    style={{ textDecoration: 'none' }}
                                  >
                                    {link.name}
                                  </Link>
                                : <a
                                    key={link.name}
                                    href={link.href}
                                    className="modern-nav-link"
                                  >
                                    {link.name}
                                  </a>
                        )}
                        {onLogout && (
                            <button className="logout-btn" onClick={onLogout}>LOG OUT</button>
                        )}
                    </nav>
                    <button
                        className="menu-toggle"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle menu"
                    >
                        <span className="menu-icon">&#9776;</span>
                    </button>
                </div>
            </header>
            <main className="modern-content">
                <div
                    style={{
                        maxWidth: 700,
                        margin: '2rem auto',
                        background: 'transparent',
                        borderRadius: '16px',
                        padding: '2rem',
                        color: '#222',
                        fontSize: '1.1rem'
                    }}
                >
                    <h1 style={{ textAlign: 'center', margin: 0 }}>Welcome{username ? `, ${username}` : ''}!</h1>
                    <p style={{ textAlign: 'center', margin: 0 }}>
                        I am Timo Laalo, MSc in computer science from Aalto university.
                        I have worked as a software engineer in Nokia. I did also my master's
                        thesis in Nokia. My thesis can be found <a
                            href="https://aaltodoc.aalto.fi/server/api/core/bitstreams/19a76fbc-3fd8-4dd4-a5c0-033271067dc6/content"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#2575fc', textDecoration: 'underline' }}
                        >
                            here
                        </a>. The product I worked with in Nokia is <a
                            href="https://www.dac.nokia.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#2575fc', textDecoration: 'underline' }}
                        >
                            Nokia Digital Automation Cloud (NDAC)
                        </a>. I was involved in performance testing and worked with 4G/5G core network functions.
                        The product was a startup within Nokia, and our adjacent teams were globally distributed.
                        My first task at Nokia was to convert 4G/5G core network build system from GNU tools
                        such as Automake to CMake. Later, I also helped build a monorepo system for our global
                        software components and worked with Gitlab and Jira integrations. For creating test
                        deployments, I utilized K8s.
                        <br /><br />
                        Currently, I am working as a developer
                        for Data Infrastructure team in a Finnish bank <a
                            href="https://www.op.fi/en/home-page"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#2575fc', textDecoration: 'underline' }}
                        >
                            Osuuspankki
                        </a>. I have also served as a scrum master for the same team.
                        I am working in the area of wealth management. My work includes workflow design and automation
                        with Control-M. I create and manage batch jobs, and I handle data ingestion to Microsoft SQL Server databases.
                        I also use T-SQL to create database procedures and functions. I work closely with business people such 
                        as Portfolio Analysts, Traders, ESG team, Back Office and Middle Office. I have helped to oursource
                        an internal software project to an external offshore consulting company.   
                        <br /><br />
                        Contact:
                        <br />
                        laalo.tim@gmail.com
                        <br />
                        +358 445566367
                        <br /><br />
                    </p>
                </div>
            </main>
            <footer className="modern-footer">
                &copy; {new Date().getFullYear()} Timo
            </footer>
        </div>
    );
};

export default About;